import { View } from 'react-native'
import Svg, { Defs, LinearGradient, Stop } from 'react-native-svg'

import { Icon } from '@/src/elements/media/Icon'
import { ICON } from '@/src/general/enums/icons'
import { colors } from '@/src/styles/colors'

const GRADIENT_ID = 'prayer-space-onboarding-primary-gradient'

export const PrimaryGradientPrayerSpaceIcon = () => (
  <View className="h-16 w-16">
    <Svg width={0} height={0} aria-hidden>
      <Defs>
        <LinearGradient id={GRADIENT_ID} x1="0" y1="0" x2="0.7" y2="0">
          <Stop offset="0" stopColor={colors.primary['gradient-inverse-from'].DEFAULT} />
          <Stop offset="1" stopColor={colors.primary['gradient-inverse-to'].DEFAULT} />
        </LinearGradient>
      </Defs>
    </Svg>
    <Icon
      name={ICON.PRAYER_SPACE}
      // GRADIENT_ID cannot be passed as variable to the fill className
      className={`[&_path]:fill-[url(#prayer-space-onboarding-primary-gradient)] h-[62px] w-[62px]`}
    />
  </View>
)
